import { BiBookContent } from "react-icons/bi";
import { BsHeadset } from "react-icons/bs";
import {
  MdOutlineManageAccounts,
  MdOutlineDashboardCustomize,
  MdOutlineSupervisorAccount,
} from "react-icons/md";
import { GiBatteryPlus } from "react-icons/gi";
import { UserRolls } from "../constant/enum/UserRolls";
import { ContentRoute } from "../routers/ContentRoutes";

export const sidebarData = [
  {
    name: "داشبور",
    path: "/dashboard",
    icon: <MdOutlineDashboardCustomize />,
    type: "menu",
    // role: [UserRolls.ADMIN_USER],
    role: ["dashboard", "baseInfo", "orders", "sell", "siteOrders", "reports"],
  },
  {
    name: "حضور غیاب",
    path: "/dashboard/RollCall",
    icon: <GiBatteryPlus />,
    type: "menu",
    role: [UserRolls.SIMPLE],
    child: ["/dashboard/RollCall"],
  },

  {
    name: "واحد حسابداری",
    path: "/dashboard/accounting/dashboard",
    icon: <MdOutlineManageAccounts />,
    type: "menu",
    role: [UserRolls.ADMIN_USER, UserRolls.ACCOUNTANT_USER],
    child: [
      "/dashboard/accounting/dashboard",
      "/dashboard/accounting/baseInfo",
      "/dashboard/accounting/orders",
      "/dashboard/accounting/sell",
      "/dashboard/accounting/siteOrders",
      "/dashboard/accounting/reports",
      "/dashboard/accounting/reports/cash-desk",
      "/dashboard/accounting/reports/banks",
      "/dashboard/accounting/reports/checks",
      "/dashboard/accounting/reports/income",
      "/dashboard/accounting/reports/costs",
      "/dashboard/accounting/baseInfo/personInfo",
      "/dashboard/accounting/baseInfo/cach-desk",
      "/dashboard/accounting/baseInfo/banks",
      "/dashboard/accounting/baseInfo/checksReceived",
      "/dashboard/accounting/baseInfo/checksPaid",
      "/dashboard/accounting/baseInfo/addAnbar",
      "/dashboard/accounting/baseInfo/income",
      "/dashboard/accounting/baseInfo/costs",
      "/dashboard/accounting/orders/invoice",
      "/dashboard/accounting/orders/sales-invoice",
      "/dashboard/accounting/orders/factors",
      "/dashboard/accounting/orders/list-factor",
    ],
  },
  {
    name: "واحد CRM",
    path: "/dashboard/crm",
    icon: <BsHeadset />,
    type: "menu",
    role: [UserRolls.ADMIN_USER, UserRolls.CRM_USER],
    child: [
      "/dashboard/crm",
      "/dashboard/crm/reporting",
      "/dashboard/crm/advancedsearch",
      "/dashboard/crm/reporting/Invoicelesscustomers",
      "/dashboard/crm/reporting/marker",
      "/dashboard/crm/reporting/Transactionsbasedonpersons",
      "/dashboard/crm/reporting/tradinglist",
      "/dashboard/crm/reporting/todayactivities",
      "/dashboard/crm/reporting/userswithoutactivity",
      "/dashboard/crm/reporting/activitiesdonetoday",
      "/dashboard/crm/reporting/firstfiles",
      "/dashboard/crm/advancedsearch",

      "/dashboard/crm/reporting/allActivityAndChances",
      "/dashboard/crm/OnlineChat",
      "/dashboard/crm/reporting/passedActivities",
      "/dashboard/crm/reporting/CluesWithoutActivity",
      "/dashboard/crm/reporting/CustomersWithoutActivity",
      "/dashboard/crm/reporting/DeletedFiles",
      "/dashboard/crm/reporting/UsersList",
      "/dashboard/crm/Chart",
      "/dashboard/crm/tags",
    ],
  },
  {
    name: "واحد محتوا",
    path: "/dashboard/content-controller/dashboard",
    icon: <BiBookContent />,
    type: "menu",
    role: [UserRolls.ADMIN_USER, UserRolls.CONTENT_USER],
    child: [
      ...ContentRoute.map(
        (item) => `/dashboard/content-controller${item.path}`
      ),
      "/dashboard/content-controller",
      "/dashboard/content-controller/slider/top-slider",
    ],
  },
  {
    name: "واحد مدیریت",
    path: "/dashboard/management",
    icon: <MdOutlineManageAccounts />,
    type: "menu",
    role: [UserRolls.ADMIN_USER, UserRolls.ACCOUNTANT_USER],
    child: [
      "/dashboard/management",
      "/dashboard/management/tickets/:id",
      "/dashboard/management/tickets/AddTicket",
      "/dashboard/management/tickets/ticketsList",
      "/dashboard/management/tickets",
      "/dashboard/management/Meetingsummary",
      "/dashboard/management/Targeting",
      "/dashboard/management/Targeting/SetHollTarget",
      "/dashboard/management/Targeting/SetPersonTarget",
    ],
  },
  {
    name: "تامین کنندگان",
    path: "/dashboard/suppliers",
    icon: <MdOutlineSupervisorAccount />,
    type: "menu",
    role: [UserRolls.ADMIN_USER, UserRolls.SUPPLIER],
    child: [
      "/dashboard/suppliers",
      "/dashboard/suppliers/accounting",
      "/dashboard/suppliers/accounting/unconfirmedOrders",
      "/dashboard/suppliers/accounting/awaitingDelivery",
      "/dashboard/suppliers/OnlineChat",
      "/dashboard/suppliers/ContentUnit",
      "/dashboard/suppliers/ContentUnit/Products",
      "/dashboard/suppliers/ContentUnit/productCategory",
      "/dashboard/suppliers/ContentUnit/productCategory/level1-product-category",
      "/dashboard/suppliers/ContentUnit/productCategory/level2-product-category",
      "/dashboard/suppliers/ContentUnit/productCategory/level2-product-category",
      "/dashboard/suppliers/ContentUnit/productCategory/level3-product-category",
      "/dashboard/suppliers/ContentUnit/productCategory/addBrand",
      "/dashboard/suppliers/ContentUnit/productCategory/addTextTemplateTable",
      "/dashboard/suppliers/ContentUnit/features",
      "/dashboard/suppliers/ContentUnit/features/level-one",
      "/dashboard/suppliers/ContentUnit/features/level-two",
      "/dashboard/ticket",
      "/dashboard/ticket/AddTicket",
      "/dashboard/ticket/ticketsList",
    ],
  },
];
